import { apiClient } from '@/core/api/client';

export type ActiveSessionStatus =
  | 'IN_PROGRESS'
  | 'STAGE_DETECTED'
  | 'MATCHMAKING'
  | 'PLAN_GENERATED'
  | 'CONCIERGE_ROUTED';

export type ActiveSession = {
  session_id: string;
  status: ActiveSessionStatus;
  care_stage_id: string | null;
} | null;

export async function fetchActiveSession(): Promise<ActiveSession> {
  const response = await apiClient.get<ActiveSession>('/navigator/active-session');
  return response.data;
}
